import EditableText from "../ui/EditableText";

interface ChecklistItem {
  text: string;
  bullets?: string[];
}

type FilingChecklistItem = string | ChecklistItem;

const checklistItems: ChecklistItem[] = [
  { text: "Applicant information (postal address)" },
  { text: "Name und/oder Darstellung der Wort- oder Bildmarke" },
  { text: "Waren- und Dienstleistungsverzeichnis (auf Englisch)" },
  {
    text: "Zusatzanträge | Priorität | Anmeldenummer | Anmeldeland | Anmeldedatum",
  },
];

export default function FilingChecklistSection({
  title = "FILING CHECKLIST",
  items = checklistItems,
  editable = false,
  onSaveTitle,
  onSaveItemText,
}: {
  title?: string;
  items?: FilingChecklistItem[];
  editable?: boolean;
  onSaveTitle?: (value: string) => void;
  onSaveItemText?: (index: number, value: string) => void;
}) {
  return (
    <section className="bg-white px-4 py-16 md:px-8">
      <div className="mx-auto max-w-6xl">
        <div className="mx-auto w-11/12 border-t border-dantzBlue" />

        <EditableText
          as="h2"
          value={title}
          editMode={editable}
          onSave={(value) => onSaveTitle?.(value)}
          className="my-12 block text-center text-[28px] font-light tracking-widest text-dantzBlue"
        />

        <div className="mx-auto flex max-w-3xl flex-col gap-6">
          {items.map((item, index) => {
            const checklistItem =
              typeof item === "string" ? { text: item } : item;
            return (
              <div key={index} className="flex flex-col gap-3">
                <div className="flex items-center gap-4">
                  <img
                    src="/images/checkbox-icon.svg"
                    alt=""
                    className="h-6 w-6 flex-shrink-0"
                  />
                  {editable ? (
                    <EditableText
                      as="span"
                      value={checklistItem.text}
                      editMode
                      onSave={(value) => onSaveItemText?.(index, value)}
                      className="font-heading text-base text-dantzBlue"
                    />
                  ) : (
                    <span className="font-heading text-base text-dantzBlue">
                      {checklistItem.text}
                    </span>
                  )}
                </div>
                {checklistItem.bullets && (
                  <ul className="ml-10 list-disc space-y-1 pl-8 text-sm text-dantzBlue">
                    {checklistItem.bullets.map((bullet) => (
                      <li key={bullet}>{bullet}</li>
                    ))}
                  </ul>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
